//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import { server } from "@/services/constants";
import { createIncorporateMatter } from "@/services/api-dtime/api_incorporate";
import { getAllCustomerListByCompany } from "@/services/api-dtime/api_customer";

export default {
  name: "incorporate-matter-add",
  components: { SuccessDialog, SuccessDialogPush },
  data() {
    return {
      entityType: "",
      clientList: [],
      selectedClient: null,
      loadingSave: false,
      activeShareholderIndex: null,
      rules: {
        required: (v) =>
          (v !== null && v !== undefined && String(v).trim() !== "") ||
          "กรุณากรอกข้อมูล",
      },

      form: {
        client_id: null,
        client_name: "",
        client_name_en: "",
        entity_type: "",
        // individual
        id_type: "national_id",
        full_name: "",
        nationality: "",
        national_id: "",
        passport_no: "",
        contact_address: "",
        contact_number: "",
        contact_email: "",
        // company
        company_name: "",
        registration_no: "",
        date_of_incorporation: "",
        registered_address: "",
        branch: "",
        authority_directors_detail: "",
        registered_capital: 0,
        number_of_shares: 0,
        par_value_per_share: 0,
        paid_up_capital: 0,
        shareholders: [
          {
            full_name: "",
            nationality: "",
            ordinary_shares: 0,
            preferred_shares: 0,
          },
        ],
        directors: [{ full_name: "", nationality: "", authorized: "" }],
        audit_firm: "",
        licensed_auditor_name: "",
        auditor_license_no: "",
        fiscal_year_start: "",
        fiscal_year_end: "",
        auditor_national_id: "",
        accountant_firm: "",
        accountant_name: "",
        accountant_national_id: "",
        vat_issued_on: "",
        is_foreign_business: false,
        foreign_business_license_files: [],
        foreign_business_certificate_files: [],
      },

      dialogAdd: false,
      dialogAddPush: false,
      text_color: "text-h5 green--text text-center",
      title: "",
      message: "",
      link: "",
    };
  },
  computed: {
    isIndividual() {
      return this.entityType === "Individual";
    },
    entityTypeLabel() {
      const map = {
        "Limited Company": "Limited Company | บริษัทจำกัด",
        "Public Company Limited": "Public Company Limited | บริษัทมหาชนจำกัด",
        Foundation: "Foundation | มูลนิธิ",
        "Representative Office": "Representative Office | สำนักงานผู้แทนการค้า",
        Individual: "Individual | บุคคลธรรมดา",
      };
      return map[this.entityType] || this.entityType;
    },
    totalOrdinaryShares() {
      return this.form.shareholders.reduce(
        (sum, sh) => sum + (Number(sh.ordinary_shares) || 0),
        0,
      );
    },
    totalPreferredShares() {
      return this.form.shareholders.reduce(
        (sum, sh) => sum + (Number(sh.preferred_shares) || 0),
        0,
      );
    },
    isOrdinarySharesExceeded() {
      return (
        Number(this.form.number_of_shares) > 0 &&
        this.totalOrdinaryShares > Number(this.form.number_of_shares)
      );
    },
    ownershipPercentages() {
      const base = Number(this.form.number_of_shares) || 0;
      const n = this.form.shareholders.length;
      if (!base || !n) return this.form.shareholders.map(() => 0);

      const SCALE = 100000; // 5 ตำแหน่งทศนิยม
      const raw = this.form.shareholders.map(
        (sh) => ((Number(sh.ordinary_shares) || 0) / base) * 100 * SCALE,
      );

      const floors = raw.map((r) => Math.floor(r));
      const target = Math.round(raw.reduce((a, b) => a + b, 0));
      let remainder = target - floors.reduce((a, b) => a + b, 0);

      const order = raw
        .map((r, i) => ({ i, frac: r - Math.floor(r) }))
        .sort((a, b) => b.frac - a.frac || a.i - b.i);

      const units = floors.slice();
      for (let k = 0; k < remainder; k++) {
        units[order[k % n].i] += 1;
      }

      return units.map((u) => u / SCALE);
    },
    totalPercentage() {
      return this.ownershipPercentages.reduce((a, b) => a + b, 0);
    },
  },
  watch: {
    "form.number_of_shares"() {
      this.clampOrdinaryShares();
    },
    "form.shareholders": {
      deep: true,
      handler() {
        this.clampOrdinaryShares();
      },
    },
  },
  async beforeCreate() {
    this.$store.state.navMenu = true;
  },
  async mounted() {
    this.$hideLoader();
    this.entityType = decodeURIComponent(this.$route.params.entity_type || "");
    this.form.entity_type = this.entityType;
    await this.loadClients();
  },
  methods: {
    formatPercent(v) {
      return (Number(v) || 0).toFixed(5) + "%";
    },
    // ปรับ ordinary_shares อัตโนมัติเมื่อผลรวมเกิน number_of_shares
    // โดยลดค่าแถวสุดท้ายลงให้ผลรวมพอดี และเคลียร์ทั้งตารางถ้า number_of_shares = 0
    // ใช้ _adjusting กัน watcher วนเรียกตัวเองซ้ำตอน method นี้แก้ค่าที่ watch อยู่
    clampOrdinaryShares() {
      if (this._adjusting) return;
      if (!this.form.shareholders.length) return;

      const numShares = Number(this.form.number_of_shares) || 0;
      const total = this.form.shareholders.reduce(
        (sum, sh) => sum + (Number(sh.ordinary_shares) || 0),
        0,
      );

      // เมื่อ Number of Shares เป็น 0 → รีเซ็ต ordinary_shares กลับเป็น 0
      // ใช้ debounce 800ms รอให้พิมพ์เสร็จก่อน ไม่งั้นจะรีเซ็ตทุกตัวอักษรจนพิมพ์ไม่ได้
      if (numShares === 0) {
        if (total > 0) {
          clearTimeout(this._zeroResetTimer);
          this._zeroResetTimer = setTimeout(() => {
            this._adjusting = true;
            this.form.shareholders.forEach((sh) => {
              sh.ordinary_shares = 0;
            });
            this.$nextTick(() => {
              this._adjusting = false;
            });
            this.setupAlertDialog(
              true,
              "แจ้งเตือน",
              "Number of Shares เป็น 0 — ระบบได้ปรับ Ordinary Shares ของผู้ถือหุ้นทุกคนกลับเป็น 0 กรุณากรอก Number of Shares ก่อน",
              "text-h5 orange--text text-center",
            );
          }, 800);
        }
        return;
      }

      clearTimeout(this._zeroResetTimer); // ยกเลิกถ้าผู้ใช้กรอก Number of Shares ทัน

      if (total <= numShares) return;

      // ⭐ ปรับ "แถวที่ผู้ใช้เพิ่งแก้" (จาก @focus) ถ้าไม่มีให้ fallback เป็นแถวสุดท้าย
      // เช่น กรณีแก้ Number of Shares ให้น้อยลงจนตารางเดิมเกิน
      const idx =
        this.activeShareholderIndex !== null &&
          this.activeShareholderIndex < this.form.shareholders.length
          ? this.activeShareholderIndex
          : this.form.shareholders.length - 1;

      this._adjusting = true;
      const targetRow = this.form.shareholders[idx];
      const othersTotal = total - (Number(targetRow.ordinary_shares) || 0);
      const adjusted = Math.max(numShares - othersTotal, 0);
      targetRow.ordinary_shares = adjusted;
      this.$nextTick(() => {
        this._adjusting = false;
      });

      this.setupAlertDialog(
        true,
        "แจ้งเตือน",
        `ผลรวม Ordinary Shares เกิน Number of Shares (${numShares}) — ระบบได้ปรับค่าแถวที่ ${idx + 1} เป็น ${adjusted} ให้อัตโนมัติ`,
        "text-h5 orange--text text-center",
      );
    },
    async loadClients() {
      try {
        const company_id = localStorage.getItem(server.COMPANYID);
        const res = await getAllCustomerListByCompany(company_id);
        const customers = res.data || [];
        this.clientList = customers.map((c) => ({
          text: c.customer_name || c.name || `Customer #${c.id}`,
          value: Number(c.id),
          raw: c,
        }));
      } catch (error) {
        console.error("Error loading clients:", error);
      }
    },

    onClientChange(selected) {
      if (selected && selected.value) {
        this.form.client_id = selected.value;
        this.form.client_name = selected.text;
        if (!this.isIndividual) {
          this.form.company_name = selected.text; // ⭐ auto-fill Company Name จาก Client ที่เลือก
        }
      } else {
        this.form.client_id = null;
        this.form.client_name = "";
      }
    },

    onClientClear() {
      this.selectedClient = null;
      this.form.client_id = null;
      this.form.client_name = "";
      if (!this.isIndividual) {
        this.form.company_name = ""; // ⭐ เคลียร์ Company Name ด้วยเมื่อ clear client
      }
    },

    nationalIdRule(v) {
      if (!v) return "Required";
      const digits = v.replace(/-/g, "");
      return digits.length === 13 || "กรุณากรอกเลขบัตรประชาชนให้ครบ 13 หลัก";
    },

    formatThaiNationalId(rawValue) {
      let d = (rawValue || "").replace(/\D/g, "").slice(0, 13);
      let result = d;
      if (d.length > 1) result = d[0] + "-" + d.slice(1);
      if (d.length > 5)
        result = result.slice(0, 2) + d.slice(1, 5) + "-" + d.slice(5);
      if (d.length > 10)
        result =
          result.slice(0, 12) + "-" + d.slice(10, 12) + "-" + d.slice(12);
      return result;
    },

    formatNationalId() {
      this.form.national_id = this.formatThaiNationalId(this.form.national_id);
    },

    formatAuditorNationalId() {
      this.form.auditor_national_id = this.formatThaiNationalId(
        this.form.auditor_national_id,
      );
    },

    formatAccountantNationalId() {
      this.form.accountant_national_id = this.formatThaiNationalId(
        this.form.accountant_national_id,
      );
    },

    addShareholder() {
      this.form.shareholders.push({
        full_name: "",
        nationality: "",
        ordinary_shares: 0,
        preferred_shares: 0,
      });
    },
    removeShareholder(i) {
      this.form.shareholders.splice(i, 1);
      this.activeShareholderIndex = null;   // ⭐ กัน index ค้างชี้ไปแถวที่ไม่มีแล้ว
    },
    addDirector() {
      this.form.directors.push({
        full_name: "",
        nationality: "",
        authorized: "",
      });
    },
    removeDirector(i) {
      this.form.directors.splice(i, 1);
    },

    isPdf(filename) {
      return filename?.toLowerCase().endsWith(".pdf");
    },
    onFblFilesSelected(e) {
      const files = Array.from(e.target.files || []);
      this.form.foreign_business_license_files.push(...files);
      e.target.value = "";
    },
    onFbcFilesSelected(e) {
      const files = Array.from(e.target.files || []);
      this.form.foreign_business_certificate_files.push(...files);
      e.target.value = "";
    },
    removeFblFile(idx) {
      this.form.foreign_business_license_files.splice(idx, 1);
    },
    removeFbcFile(idx) {
      this.form.foreign_business_certificate_files.splice(idx, 1);
    },

    validateForm() {
      if (this.isIndividual) {
        if (!this.form.client_name.trim()) {
          this.setupAlertDialog(
            true,
            "Check information",
            "กรุณากรอก Client Name",
            "text-h5 red--text text-center",
          );
          return false;
        }
        if (!this.form.full_name.trim()) {
          this.setupAlertDialog(
            true,
            "Check information",
            "กรุณากรอก Full Name",
            "text-h5 red--text text-center",
          );
          return false;
        }
        if (this.form.id_type === "national_id") {
          const nidCheck = this.nationalIdRule(this.form.national_id);
          if (nidCheck !== true) {
            this.setupAlertDialog(
              true,
              "Check information",
              nidCheck,
              "text-h5 red--text text-center",
            );
            return false;
          }
        } else {
          if (!this.form.passport_no || !this.form.passport_no.trim()) {
            this.setupAlertDialog(
              true,
              "Check information",
              "กรุณากรอกเลขที่หนังสือเดินทาง",
              "text-h5 red--text text-center",
            );
            return false;
          }
        }
      } else {
        if (!this.selectedClient || !this.form.client_id) {
          this.setupAlertDialog(
            true,
            "Check information",
            "กรุณาเลือก Client Name",
            "text-h5 red--text text-center",
          );
          return false;
        }
        if (!this.form.company_name.trim()) {
          this.setupAlertDialog(
            true,
            "Check information",
            "กรุณากรอก Company Name",
            "text-h5 red--text text-center",
          );
          return false;
        }
        if (!this.form.registration_no || !this.form.registration_no.trim()) {
          this.setupAlertDialog(
            true,
            "Check information",
            "กรุณากรอก Registration No.",
            "text-h5 red--text text-center",
          );
          return false;
        }
        if (!this.form.date_of_incorporation) {
          this.setupAlertDialog(
            true,
            "Check information",
            "กรุณากรอก Date of Incorporation",
            "text-h5 red--text text-center",
          );
          return false;
        }
        if (
          !this.form.registered_address ||
          !this.form.registered_address.trim()
        ) {
          this.setupAlertDialog(
            true,
            "Check information",
            "กรุณากรอก Registered Address",
            "text-h5 red--text text-center",
          );
          return false;
        }
        if (this.form.is_foreign_business) {
          if (this.form.foreign_business_license_files.length === 0) {
            this.setupAlertDialog(
              true,
              "Check information",
              "กรุณาอัปโหลดใบอนุญาตประกอบธุรกิจคนต่างด้าวอย่างน้อย 1 ไฟล์",
              "text-h5 red--text text-center",
            );
            return false;
          }
          if (this.form.foreign_business_certificate_files.length === 0) {
            this.setupAlertDialog(
              true,
              "Check information",
              "กรุณาอัปโหลดหนังสือรับรองประกอบธุรกิจคนต่างด้าวอย่างน้อย 1 ไฟล์",
              "text-h5 red--text text-center",
            );
            return false;
          }
        }
      }
      return true;
    },

    buildFormData() {
      const fd = new FormData();
      const company_id = localStorage.getItem(server.COMPANYID);
      const user_id = localStorage.getItem(server.USER_ID);

      if (this.form.client_id) {
        fd.append("client_id", this.form.client_id);
      }

      const fields = [
        "client_name",
        "client_name_en",
        "entity_type",
        "nationality",
        "registration_no",
        "company_name",
        "date_of_incorporation",
        "registered_address",
        "branch",
        "authority_directors_detail",
        "audit_firm",
        "licensed_auditor_name",
        "auditor_license_no",
        "fiscal_year_start",
        "fiscal_year_end",
        "auditor_national_id",
        "accountant_firm",
        "accountant_name",
        "accountant_national_id",
        "vat_issued_on",
        "id_type",
        "full_name",
        "national_id",
        "passport_no",
        "contact_address",
        "contact_number",
        "contact_email",
      ];
      fields.forEach((key) => {
        if (
          this.form[key] !== null &&
          this.form[key] !== undefined &&
          this.form[key] !== ""
        ) {
          fd.append(key, this.form[key]);
        }
      });

      fd.append(
        "registered_capital",
        parseFloat(this.form.registered_capital) || 0,
      );
      fd.append("number_of_shares", parseInt(this.form.number_of_shares) || 0);
      fd.append(
        "par_value_per_share",
        parseFloat(this.form.par_value_per_share) || 0,
      );
      fd.append("paid_up_capital", parseFloat(this.form.paid_up_capital) || 0);

      fd.append("company_id", company_id);
      fd.append("user_create", user_id);
      fd.append("status", "Active");
      fd.append(
        "is_foreign_business",
        this.form.is_foreign_business ? "true" : "false",
      );

      const validShareholders = this.form.shareholders.filter(
        (s) => s.full_name.trim() !== "",
      );
      fd.append("shareholders", JSON.stringify(validShareholders));

      const validDirectors = this.form.directors.filter(
        (d) => d.full_name.trim() !== "",
      );
      fd.append("directors", JSON.stringify(validDirectors));

      fd.append(
        "fbl_count",
        String(this.form.foreign_business_license_files.length),
      );
      fd.append(
        "fbc_count",
        String(this.form.foreign_business_certificate_files.length),
      );
      this.form.foreign_business_license_files.forEach((file) => {
        fd.append("file", file);
      });
      this.form.foreign_business_certificate_files.forEach((file) => {
        fd.append("file", file);
      });

      return fd;
    },

    async saveOnly() {
      if (!this.validateForm()) return;
      this.loadingSave = true;
      this.$showLoader();
      try {
        const fd = this.buildFormData();
        await createIncorporateMatter(fd);
        this.$hideLoader();
        this.loadingSave = false;
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          true,
          "Success",
          "บันทึกข้อมูลสำเร็จ",
          "text-h5 green--text text-center",
          "/incorporate-matter-list",
        );
      } catch (error) {
        this.$hideLoader();
        this.loadingSave = false;
        console.error("Error creating matter:", error);
        this.setupAlertDialog(
          true,
          "Error",
          "เกิดข้อผิดพลาดในการบันทึก",
          "text-h5 red--text text-center",
        );
      }
    },

    async saveAndCreateDocket() {
      if (!this.validateForm()) return;
      this.loadingSave = true;
      this.$showLoader();
      try {
        const fd = this.buildFormData();
        const res = await createIncorporateMatter(fd);
        this.$hideLoader();
        this.loadingSave = false;
        const matterId = res.data?.id || res.data?.data?.id;
        this.$router.push(
          `/incorporate-docket-add?matter_id=${matterId || ""}`,
        );
      } catch (error) {
        this.$hideLoader();
        this.loadingSave = false;
        console.error("Error creating matter:", error);
        this.setupAlertDialog(
          true,
          "Error",
          "เกิดข้อผิดพลาดในการบันทึก",
          "text-h5 red--text text-center",
        );
      }
    },

    // ⭐ FIX: คอมโพเนนต์ SuccessDialog.vue ผูก v-model กับ
    // $store.state.global_dialog โดยตรง (ไม่ได้ใช้ "status" prop ที่ส่งเข้าไป
    // เลยแม้แต่จุดเดียว) ดังนั้นถ้าตั้งแค่ this.dialogAdd = status เฉย ๆ
    // popup จะไม่เด้งขึ้นมาเลย ต้อง sync เข้า store ทุกครั้งที่เรียกใช้
    // (บั๊กเดียวกับที่พบและแก้ไปแล้วใน IncorporateDocketAdd.vue —
    // เพิ่มบรรทัดนี้ให้ตรงกัน เพื่อให้ popup แจ้งเตือนเด้งขึ้นจริง
    // เวลากรอกข้อมูลที่มี * ไม่ครบ)
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.$store.state.global_dialog = status; // ⭐ ขาดอันนี้ทำให้ dialog ไม่เด้ง
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAddPush = status;
      this.text_color = text_color;
      this.link = link;
      this.$store.state.global_push_dialog = status; // ⭐ กันพลาดถ้าเรียกซ้ำโดยไม่ set store เอง
    },
  },
};
